import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Autocomplete,
  Typography,
  CircularProgress,
} from "@mui/material";
import { oauthClientService } from "../../utils/services/o-auth-client";
import { toast } from "react-toastify";

const AuthenticateModal = ({ open, onClose, client }) => {
  const [selectedUri, setSelectedUri] = useState(null);
  const [loading, setLoading] = useState(true);
  const redirectUriOptions = client?.redirect_uris || [];
  const [clientSecret, setClientSecret] = useState("");

  const generateRandomState = (length = 16) => {
    const chars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";
    for (let i = 0; i < length; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
  };

  const handleAuthenticate = async () => {
    const state = generateRandomState();
    localStorage.setItem("oauth_state", state);
    localStorage.setItem("oauth_selected_uri", selectedUri);

    const payload = {
      client_id: client.client_id,
      client_secret: clientSecret,
      scope: "read write",
      response_type: "code",
      redirect_uri: selectedUri,
      state,
    };

    try {
      const response = await oauthClientService.authorize(payload);
      toast.success("Authenticated sucessfully.");

      const url = new URL(response.redirect);
      const code = url.searchParams.get("code");
      const returnedState = url.searchParams.get("state");
      const originalState = localStorage.getItem("oauth_state");

      if (originalState && returnedState === originalState) {
        localStorage.setItem("oauth_code", code);
        localStorage.setItem("oauth_state_valid", "true");
        localStorage.setItem("authenticatedClientId", client._id);
      } else {
        localStorage.setItem("oauth_state_valid", "false");
        localStorage.removeItem("oauth_code");
        localStorage.removeItem("authenticatedClientId");
      }
      setSelectedUri(null);
      onClose();
    } catch (error) {
      console.error("Authentication error:", error);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Authenticate Client</DialogTitle>
      <DialogContent>
        <TextField
          label="Client ID"
          value={client?.client_id || ""}
          fullWidth
          disabled
          margin="normal"
          size="small"
        />
        <TextField
          required
          label="Client Secret"
          value={clientSecret}
          fullWidth
          margin="normal"
          size="small"
          onChange={(e) => setClientSecret(e.target.value)}
        />
        <Autocomplete
          size="small"
          options={redirectUriOptions}
          value={selectedUri}
          onChange={(e, newValue) => setSelectedUri(newValue)}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Redirect URI"
              margin="normal"
              fullWidth
              required
            />
          )}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          Cancel
        </Button>
        <Button
          onClick={handleAuthenticate}
          variant="contained"
          disabled={!selectedUri}
        >
          Authenticate
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AuthenticateModal;
